/**
 * The server address an extension talks to, with a copy button. Each build
 * already has it filled in; this is for checking, or for a build made for a
 * different server.
 */
import { useState } from 'react';

/** The same backend this admin app talks to. */
export const SERVER_ADDRESS = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function ServerAddress() {
  const [note, setNote] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SERVER_ADDRESS);
      setNote('Copied');
    } catch {
      setNote('Could not copy - select the address and copy it by hand.');
    }
    setTimeout(() => setNote(''), 3000);
  };
  return (
    <div>
      <p className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Server address (already filled in for you in the extension)
      </p>
      <div className="flex gap-2">
        <input
          readOnly
          value={SERVER_ADDRESS}
          onFocus={(e) => e.target.select()}
          className="flex-1 font-mono text-xs px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-800"
        />
        <button
          onClick={copy}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-sm"
        >
          Copy
        </button>
      </div>
      {note && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{note}</p>}
    </div>
  );
}
